import React, { Component, Context } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import clsx from "clsx";
import PreviewIcon from "@material-ui/icons/VisibilityOutlined";
// import LayoutUtils from "../../../utils/layout.ts__";
import { ImageProps } from "./ImageView";
import { IImage, ImageMedia, EMPTY_IMG } from "../../../models/Image";
import { formatKB } from "../../../utils";
import { getDateDisplay } from "../../../utils/date-utils";
// import MediaOverlay from "./MediaOverlay.tsx__";
// import MediaOverlay from "./MediaOverlay";
// import { AppContext } from '../../../contexts/AppContext';
// import { StorageConfig } from "../../../models/Storage.ts__";
import { getViewImage, capitalize } from "../../../utils";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import MediaView from "./MediaView";
import { UIActions } from "../../peer-support/Actions";
import UILoader from "../UILoader";
import { FileType } from "../../../laco-common/base/models/IFile";
import "./ImageThumbnails.scss";

export type ImageThumbnailProps = {
	images: IImage[];
	selectedImages?: IImage[];
	imageIndividualProps?: { className?: string }[];
	deleteCallback?: (image: IImage, index: number) => void;
	noCenterGrid?: boolean;
	isProfile?: boolean;
	isFullWidthBadge?: boolean;
	displayShare?: boolean;
	displayMetaData?: boolean;
};

class ImageThumbnails extends Component<RouteComponentProps & ImageThumbnailProps & ImageProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;
	private _isMounted: boolean = false;
	private historySub: any;

	// static contextType = AppContext;

	// public context = {
	// 	BADGE_DIMENSIONS: { width: 100, height: 100 },
	// 	IMG_DIMENSIONS: { width: 350, height: 192 },
	// };

	state = {
		loading: false,
		images: [],
		selectedImages: this.props.selectedImages,
		modalVisible: false,
		selectedImage: null,
		selectedIndex: 0,
	};

	componentDidMount() {
		this._isMounted = true;
		this.setState({ images: this.props.images });
		this.initViewImage(this.props.location);
		this.historySub = this.props.history.listen((location, action) => {
			this.initViewImage(location);
		});
	}

	componentWillUnmount() {
		this._isMounted = false;
		this.historySub();
	}

	componentWillReceiveProps(nextProps: ImageThumbnailProps) {
		// if (this._isMounted) {
		this.setState({
			images: nextProps.images,
			selectedImages: nextProps.selectedImages,
			modalVisible: this.state.modalVisible,
		});
		this.initViewImage(this.props.location);
		// }
	}

	// check if need to open modal - shared link
	initViewImage(location: { hash: string; search: string }) {
		const img = getViewImage(location);
		if (img) {
			setTimeout(() => {
				this.props.images.forEach((image: IImage, index: number) => {
					// console.debug(image)
					if (image.filename === img) {
						this.openModal(image, index);
						return;
					}
				});
			}, 700);
		}
	}

	getImageProps(index: number) {
		if (this.props.imageIndividualProps) {
			return this.props.imageIndividualProps[index];
		}
	}

	getImageClassName(index: number): string {
		if (this.props.imageIndividualProps && this.props.imageIndividualProps[index]) {
			return this.props.imageIndividualProps[index].className;
		}
	}

	getWidth(): number {
		if (this.props.viewWidth) return this.props.viewWidth;
		if (this.props.isProfile && !this.props.viewFull) return 100; // dana TODO this.context.BADGE_DIMENSIONS.width;
		return 100; // dana TODO // this.context.IMG_DIMENSIONS.width;
	}

	getHeight(): number {
		if (this.props.viewFull) return undefined;
		if (this.props.isProfile) return 100; // dana TODO //this.context.BADGE_DIMENSIONS.height;
		return this.props.viewHeight || 100; // dana TODO //this.context.IMG_DIMENSIONS.height;
	}

	openModal(image: IImage, i: number) {
		this.updateSelectedImgIndex(i);
	}

	updateSelectedImgIndex(i: number) {
		// set visible image
		// validate index
		let index = i;
		if (index >= this.props.images.length) {
			index = 0;
		} else if (index < 0) {
			index = this.props.images.length - 1;
		}
		this.setState({ selectedIndex: index });

		const selectedMedia: IImage = this.props.images[index];
		if (selectedMedia.fileType == FileType.VIDEO) {
			if (this._isMounted) {
				this.setState({ modalVisible: true });
			}
		} else {
			let img = new Image();
			img.src = selectedMedia.url;
			img.onload = (e) => {
				// wait for image to load
				if (this._isMounted) {
					this.setState({ modalVisible: true });
				}
			};
		}
	}

	getGridClasses(): string {
		let css: string = "d-flex flex-row flex-wrap";
		// if (LayoutUtils.getRes() <= LayoutUtils.GALLERY_XS_SINGLE_COL_BREAKPOINT) {
		// 	css += " justify-content-center ";
		// } else if (!this.props.noCenterGrid && this.state.images.length === 2) {
		// 	css += " display-2img justify-content-center ";
		// } else if (this.state.images.length === 1 && !this.props.noCenterGrid) {
		// 	css += " justify-content-center ";
		// } else {
		// 	css += " justify-content-between ";
		// }
		return css;
	}

	renderImage(image: IImage, i: number, isEmpty?: boolean) {
		const selected: boolean = !!(this.state.selectedImages || []).find((img: IImage) => {
			const imgTokenIndex: number = img.url.lastIndexOf("&token");
			const imageTokenIndex: number = image.url.lastIndexOf("&token");
			const imgUrl: string = imgTokenIndex > 10 ? img.url.substr(0, imgTokenIndex) : img.url;
			const imageUrl: string = imageTokenIndex > 10 ? image.url.substr(0, imageTokenIndex) : image.url;
			return (
				(img.docId && image.docId && img.docId === image.docId) ||
				img.filename === image.filename ||
				imgUrl === imageUrl
			);
		});

		const width: number = this.getWidth();

		return (
			<div key={i} className="position-relative" style={{ width: `${width}px` }}>
				<MediaView
					key={i}
					image={image}
					index={i}
					className={clsx(
						"media-view",
						isEmpty && " mss-empty-image",
						!isEmpty && this.getImageClassName(i),
						!isEmpty && selected && "image-view-selected"
					)}
					viewWidth={width}
					viewHeight={this.getHeight()}
					autoWidth={this.props.autoWidth}
					containImage={this.props.containImage}
					viewFull={
						this.props.viewFull === false && !this.props.isFullWidthBadge
							? false
							: this.props.viewFull || this.props.isFullWidthBadge
					}
					displayThumb={this.props.displayThumb === false ? false : this.props.displayThumb || true}
					awaitImgExists={this.props.awaitImgExists}
					displayEnlargeHover={isEmpty ? false : this.props.displayEnlargeHover}
					enlargeText={this.props.enlargeText}
					// enlargeCallback={
					// 	this.props.enlargeCallback
					// 		? () => this.props.enlargeCallback(image, i)
					// 		: this.props.onClick
					// 		? null
					// 		: this.openModal.bind(this, image, i)
					// }
					onClick={this.props.onClick ? () => this.props.onClick(image, i) : undefined}
				>
					{this.props.children}

					{image.url && (
						<UIActions
							data={image}
							itemName={capitalize(image.fileType)}
							// deleteName={field.label}
							customActions={[
								{
									title: "View File",
									icon: PreviewIcon,
									callback: (image: IImage) => {
										window.open(image.url, "_blank");
										return Promise.resolve();
									},
								},
							]}
							// onDelete={!!url ? () => deleteCallback(file) : undefined}
							// isSimpleDelete={true}
						/>
					)}

					{/* {!isEmpty && this.props.deleteCallback && (
					<i
						className="pi pi-trash animated fadeIn"
						title="Delete"
						onClick={(e) => {
							this.props.deleteCallback(image, i);
						}}
					></i>
				)} */}
				</MediaView>

				{this.props.displayMetaData && !!image.url && (
					<div className="image-meta-data w-100 mb-1 text-xs">
						<div className="d-flex flex-row justify-content-between mb-2 text-gray text-xxs">
							<span>{getDateDisplay(image.created, null)}</span>
							<span>{formatKB(image.size)}</span>
						</div>
						<div>{image.title}</div>
					</div>
				)}
			</div>
		);
	}

	// append empty image to grid to adjust layout
	appendEmptyImage() {
		const emptyImage: IImage = ImageMedia.create(EMPTY_IMG, EMPTY_IMG, "");
		return this.renderImage(emptyImage, -1, true);
	}

	render() {
		if (this.state.loading) return <UILoader display={true} />;
		return (
			<div className={"image-thumbnails text-center  " + (this.props.className || "")}>
				<div className={this.getGridClasses()}>
					{this.state.images.map((image: IImage, i: number) => {
						return this.renderImage(image, i);
					})}
					{/* {LayoutUtils.isDesktopRes() &&
						this.state.images.length > 3 &&
						this.state.images.length % 3 !== 0 &&
						!this.props.isProfile &&
						this.appendEmptyImage()} */}
				</div>
				{/* <MediaOverlay
					displayMedia={this.state.modalVisible}
					displayShare={this.props.displayShare === false ? false : this.props.displayShare || true}
					onClose={() => {
						this.setState({ modalVisible: false });
					}}
					selectedMedia={this.props.images[this.state.selectedIndex]}
				>
					<i
						className="pi pi-angle-right"
						title="Next"
						onClick={() => this.updateSelectedImgIndex(this.state.selectedIndex + 1)}
					></i>
					<i
						className="pi pi-angle-left"
						title="Previous"
						onClick={() => this.updateSelectedImgIndex(this.state.selectedIndex - 1)}
					></i>
				</MediaOverlay> */}
			</div>
		);
	}
}

export default withRouter(ImageThumbnails);
